export default "__VITE_ASSET__BoMp_vOe__"